import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { SideNavItemBaseComponent } from '../sidenav/sidenav.item.base.component';
import { ApplicationState } from '@jms/tenant/module.jms.state';
import { AvatarModule } from '@jms/ui/ui.avatar';

@Component({
    selector: 'user-nav',
    templateUrl: './user.nav.component.html',
    styleUrls: ['./user.nav.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, RouterModule, OverlayModule, CdkOverlayOrigin, CdkConnectedOverlay, AvatarModule]
})
export class UserNavComponent extends SideNavItemBaseComponent {

    @Input() protected accountUrl: string;
    @Input() protected state: ApplicationState;
    @Output() protected logout = new EventEmitter<any>();

    protected positions = [{
        originX: 'end',
        originY: 'center',
        overlayX: 'start',
        overlayY: 'center',
        offsetY: -12,
    } as ConnectedPosition];

    constructor(
        protected overlay: Overlay,
        public cdr: ChangeDetectorRef,
    ) {
        super(cdr);
    }
}
